import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  makeStyles
} from '@material-ui/core';
import LoadingButton from './LoadingButton';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  error: {},
  warning: {},
  success: {},
  confirmButton: {
    '$error &': {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.dark
      }
    }
  }
}));

export interface ConfirmDialogProps extends DialogProps {
  open: boolean
  onClose?: (confirmed: boolean) => void
  title?: string
  message?: React.ReactNode
  confirmText?: React.ReactNode
  confirmDisabled?: boolean
  severity?: 'info' | 'success' | 'error' | 'warning'
  cancelText?: React.ReactNode
  cancelDisabled?: boolean,
  pending?: boolean
}

export default function ConfirmDialog ({
  open,
  onClose = () => {},
  title = 'Confirm?',
  message = '',
  confirmText = 'Ok',
  confirmDisabled = false,
  severity = 'info',
  cancelText = 'Cancel',
  cancelDisabled = false,
  pending = false,
  ...props
}: ConfirmDialogProps) {
  const handleCancel = () => onClose(false);
  const handleOk = () => onClose(true);
  const classes = useStyles();
  const rootClass = clsx({
    [classes.error]: severity === 'error',
    [classes.warning]: severity === 'warning',
    [classes.success]: severity === 'success'
  });
  return (
    <Dialog
      className={rootClass}
      open={open}
      onClose={handleCancel}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      {...props}
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCancel}
          disabled={cancelDisabled || pending}

        >
          {cancelText}
        </Button>
        <LoadingButton
          variant='contained'
          className={classes.confirmButton}
          onClick={handleOk}
          disabled={confirmDisabled || pending}
          color='primary'
          autoFocus
          pending={pending}
        >
          {confirmText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
